<template>
  <div
    v-if="count"
    class="card m-0"
  >
    <div class="px-4 pt-2 pb-4">
      <h3
        class="m-0 mb-2"
        v-text="'Categories'"
      />
      <ul class="list-reset m-0">
        <li
          v-for="category in categories"
          :key="category.uuid"
          :class="{ active: statusIs(category.attributes.slug) }"
        >
          <a
            :href="category._links.frontend.self"
            class="no-underline"
            v-text="category.attributes.title"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CommunicationCategoriesList',
  computed: {
    ...mapState({
      count: state => state.communication.categories.data.length,
      categories: state => state.communication.categories.data,
    }),
  },
  async mounted() {
    await this.$nextTick()

    this.communicationGetCategories()
      .then(() => {
        this.loaded = true
      })
  },
  methods: {
    ...mapActions([
      'communicationGetCategories',
    ]),
    statusIs(status) {
      return this.status === status
    },

    mobileNavigation(e){
      window.location = e.target.value
    },
  },
}
</script>
